export enum RefinementBehavior {
	OPTIMIZED = 1,
	REFINED = 0
}

